
import React from 'react';
import { FlowRender } from "../flow-render";
import { RadioButton, RADIO_SINGLE_RANDOM_VALUE } from "../prm/radio-button";
import { Name } from "../prm/name";
import { GreyBox } from "../../client/funcs/utils";
import faker from 'faker';
import {is_transfer as is_transfer_f} from "../onboarding-utils";

const investments_knowledge = new RadioButton(
  new Name("investments_knowledge",
    "I would describe my knowledge of investments as:"),
  [
    new Name("minimal", "Minimal knowledge"),
    new Name("mutual_funds", "I have bought Mutual Funds in the past"),
    new Name("invest_stocks", "I actively invest in stocks, ETFs, bonds or commodities"),
  ], [], RADIO_SINGLE_RANDOM_VALUE);

const investment_focus = new RadioButton(
  new Name("investment_focus",
    "When I invest, I am focused on:"),
  [
    new Name("not_losing_money",
      "Not losing money, so I would consider myself risk adverse"),
    new Name("neutral",
      "Equally concerned about both the risk and return on my investments"),
    new Name("making_money",
      "Making money, so I would consider myself a risk taker"),
  ], [], RADIO_SINGLE_RANDOM_VALUE);

const current_investments = new RadioButton(
  new Name("current_investments",
    "Select some of the investments you currently own. (Select all that apply):"),
  [
    new Name("none", "None"),
    new Name("mutual_funds", "Mutual Funds"),
    new Name("stocks_bonds_etfs", "Stocks, Bonds, or ETFs"),
    new Name("properties_commodities", "Investment Properties, Gold or Commodities"),
  ],
  ["none"],
);
current_investments.doRadio = false;
current_investments.do_checkbox = true;

class Risk_1 extends FlowRender {

  constructor(index) {
    super(index, [
      investments_knowledge,
      investment_focus,
      current_investments,
    ]);
    current_investments.onChangeCallback = this.onChange;
    this.url = "risk_1";
  }

  onChange = (component, newState, id) => {
    const is_none_clicked = id === 'current_investments|none';

    // Check current_investments. If all the checkboxes are off, turn on 'none'
    const selected_values = current_investments.getSelectedValues(newState);
    if (selected_values.length === 0) {
      current_investments.setValues(newState, ['none'], true);
    } else if (selected_values.includes("none") && selected_values.length > 1) {
      if (is_none_clicked) {
        // deselect the rest
        const all_other_values = ['mutual_funds', 'stocks_bonds_etfs', 'options_futures',
          'properties_commodities', 'international_securities'];
        current_investments.setValues(newState, all_other_values, false);
      } else {
        // unselect none
        current_investments.setValues(newState, ['none'], false);
      }
    }
  };

  onFinish = (component) => {
    if (component.state.dirty) {
      component.props.clearOnboardingItem(
        component.getOnboardingIndex(), ["alloc"], component.props.username);
      //component.calcCategoryAllocation();
    }
  }

  canNavigateNext(component) {
    const state = component.state;
    const highlight_rects = [];
    const is_proxy = component.props.is_proxy;
    const is_transfer = is_transfer_f(component.getOnboardingData());

    const fill_0 = investments_knowledge.isFilledElseHighlight(state, highlight_rects);
    const fill_1 = investment_focus.isFilledElseHighlight(state, highlight_rects);

    if (fill_0 && fill_1) {
      const next_segment = (is_proxy || is_transfer) ? "/crypto" : "/risk_2";
      return component.getRootUrl() + next_segment;
    }

    component.setState({ highlight_rects });
    return null;
  }


  setRandomValues(state, component) {
    super.setRandomValues(state);
    const ids = [];

    current_investments.clear(state);

    for(let i=1 ; i < current_investments.buttonList.length; i++) {
      const val = !!faker.random.number({min: 0, max: 1, precision: 1 });
      if (val) {
        ids.push(current_investments.buttonList[i].id.split("|")[1]);
      }
    }
    current_investments.setValues(state, ids, true);
  }

  renderItem = (component, menu) => {

    // const checkbox_style = {
    //   float: "left",
    //   marginTop: "0.25rem"
    // };
    const buttons = menu.buttonList.map((name, index) => {
    //   return menu.renderCheckboxLabel(index, component, checkbox_style);
        return (<div style={{ width: 'fit-content' }} key={index}>{menu.renderRadioLabel(index, component)}</div>)  
    });
    const container_style = {
      paddingBottom: "1rem",
    };

    return (
      <div style={container_style}>
        <GreyBox>
          <div>
            <span>{menu.name.label}</span>
          </div>
          <div style={{height: "1rem"}}/>
          { buttons }
        </GreyBox>
      </div>
    )
  };

  renderBody = component => {

    const text = "Let’s find out how comfortable you are with investing so we can "
      + "tailor a portfolio just for you.";
    const textStyle = {
      fontSize: "1.5rem",
    }
    return (
      <div>
        <div><span style={textStyle}>{text}</span></div>
        <div style={{height: "1rem"}}/>
        { this.renderItem(component, investments_knowledge) }
        { this.renderItem(component, investment_focus) }
        { this.renderItem(component, current_investments) }
      </div>
    )
  }

  render = component => {
    return (
      <div>
        { this.renderHighlightRects(component) }
        { this.renderTitle(component, "Comfort with Risk", "50%", "952128195")}
        { this.renderProgress(component) }
        { this.renderSingleColumn(this.renderBody(component)) }
        { this.renderNextButtonRow(component, true)}
      </div>
    )
  }
};

export { Risk_1, investments_knowledge, investment_focus, current_investments };
